import React from 'react'
import QRCodeGenerator from './QRCodeGenerator';

const PrintBundleLabel = ({ qrCodeSrc, bundleId }) => {
    return (
        <div
            style={{
                width: '100mm',
                height: '50mm',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '5mm 0',
                boxSizing: 'border-box',
                fontSize: '12px',
                textAlign: 'center',
            }}
        >
            <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                <QRCodeGenerator value={qrCodeSrc} size={75} />
            </div>
            <div style={{ paddingTop: '4mm' }}>
                <strong>Bundle {bundleId}</strong>
            </div>
        </div>
    );
}

export default PrintBundleLabel;
